import { ArrowDownIcon } from 'shared/ui/icons';

const COLLAPSE_CLOSED =
  'transition-all duration-300 ease-in-out overflow-hidden max-h-0 opacity-0 p-0';
const COLLAPSE_OPEN =
  'transition-all duration-300 ease-in-out overflow-hidden max-h-[1000px] opacity-100 py-4 overflow-auto';

const CollapsibleSection = ({ title, isOpen, onToggle, children }) => (
  <div className="bg-green-500 bg-opacity-5 rounded-lg px-4 py-3 flex flex-col">
    <div className="w-full flex items-center justify-between gap-2">
      <p className="text-base font-medium">{title}</p>
      <div className="flex gap-x-2">
        <button
          onClick={onToggle}
          className="flex items-center justify-center cursor-pointer"
          data-testid="collapse-panel-patient-info"
        >
          <ArrowDownIcon
            className={`transform transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </button>
      </div>
    </div>
    <div
      className={`flex w-full items-center gap-2 ${
        isOpen ? COLLAPSE_OPEN : COLLAPSE_CLOSED
      }`}
    >
      {children}
    </div>
  </div>
);

export default CollapsibleSection;
